import './page-kontrollery.css';

import ScrollToTop from '../../@common.blocks/ScrollToTop/index';

import Text from '../../@common.blocks/Text/index';
import { Link } from 'react-router-dom';
import WorkLogo_13 from '../../pictures/worklogo13.png';
import WorkLogo_15 from '../../pictures/worklogo15.png';
import WorkLogo_16 from '../../pictures/worklogo16.png';
import WorkLogo_17 from '../../pictures/worklogo17.png';
import WorkLogo_18 from '../../pictures/worklogo18.png';
import WorkLogo_19 from '../../pictures/worklogo19.png';
import WorkLogo_20 from '../../pictures/worklogo20.png';

const PageKontrollery = () => {
  return (
    <section className="page-kontrollery">
      <ScrollToTop />

      <div className="page-kontrollery__wrapper">
        <div className="page-kontrollery__content">
          <div
            className="page-kontrollery__content-img"
            id="kontrollery_SIEMENS"
          >
            <img src={WorkLogo_13} alt="" />
          </div>
          <Text component="p" section="equipping">
            Промышленные контроллеры Siemens используются в самых разных
            отраслях промышленности. Особенно широкое распространение получили
            модели Simatic S7-300, S7-400 и S7-1200, что объясняется их высоким
            качеством и надежностью. Программируемые логические контроллеры
            Siemens имеют ряд технологических преимуществ перед конкурентами:
            многофункциональность; возможность создания систем автоматизации
            различной сложности, возможность эксплуатации ПЛК в сложных
            условиях; практически полная автономность; простота в обслуживании.
            Контроллеры Siemens — это эффективное решение для создания
            автоматизации! Официальный сайт
            <Link to="https://ru-siemens.com/">
              <div> https://ru-siemens.com/</div>
            </Link>
          </Text>
          <div
            className="page-kontrollery__content-img"
            id="kontrollery_UNITRINICS"
          >
            <img src={WorkLogo_15} alt="" />
          </div>
          <Text component="p" section="equipping">
            Unitronics разрабатывает, производит и продвигает передовые решения
            для управления и автоматизации. Мы предлагаем широкий модельный ряд
            PLC, PLC со встроенным HMI, полную линейку преобразователей частоты
            (ПЧ), весь спектр модулейввода/вывода и вспомогательного
            оборудования, а также программное обеспечение для программирования
            .Unitronics предлагает решения начиная от микро-PLC + HMI для
            управления простым оборудованием до высокопроизводительных
            многофункциональных контроллеров с богатым ассортиментом встроенных
            и удаленных модулейввода/вывода и различными вариантами
            коммуникаций, в том числе с поддержкой стратегии «Индустрия 4.0»
            Официальный сайт
            <Link to="https://www.unitronics.ru/">
              <div>https://www.unitronics.ru/</div>
            </Link>
          </Text>
          <div className="page-kontrollery__content-img" id="kontrollery_ONI">
            <img src={WorkLogo_16} alt="" />
          </div>
          <Text component="p" section="equipping">
            Продукция ONI выпускается на контрактных зарубежных производственных
            площадках — мировых лидерах по производству оборудования для
            промышленной автоматизации, одна из ключевых расположена в Южной
            Корее. Команда сотрудников ONI обладает солидным опытом работы в
            ведущих международных компаниях по производству электроники.
            Благодаря этому они смогли реализовать все самые современные и
            передовые технологии в процессе разработки и создания оборудования
            ONI.Все оборудование ONI проходит многоступенчатый контроль качества
            и тестирование на эксплуатацию в рабочих условиях в собственном
            испытательном центре. На продукцию ONI предоставляется долгосрочная
            гарантия, техническая поддержка и, при необходимости, качественное
            сервисное обслуживание.Официальный сайт
            <Link to="https://oni-system.com/">
              <div>https://oni-system.com/</div>
            </Link>
          </Text>
          <div
            className="page-kontrollery__content-img"
            id="kontrollery_HELMHOLZ"
          >
            <img src={WorkLogo_17} alt="" />
          </div>
          <Text component="p" section="equipping">
            Helmholz — ваш специалист, когда дело касается сложных продуктов для
            ваших проектов автоматизации. Благодаря современным умным системным
            решениям от Helmholz высокие требования, предъявляемые к
            промышленным сетям в эпоху растущей автоматизации, могут быть
            выполнены как надежно, так и эффективно, включая высокий уровень
            удобства эксплуатации. Широкий спектр продукции варьируется от
            децентрализованной системы ввода-вывода до коммутаторов и
            повторителей, шлюзов, шлюза NAT/брандмауэра и безопасного удаленного
            доступа к машинам IoT.Компания Helmholz стремится предложить
            идеальное решение для любой задачи автоматизации: с помощью
            ориентированных на рынок, интеллектуальных продуктов и простой,
            быстрой и эффективной поддержки.Официальный сайт
            <Link to="   https://www.helmholz.de/">
              <div> https://www.helmholz.de/</div>
            </Link>
          </Text>
          <div className="page-kontrollery__content-img" id="kontrollery_OBEH">
            <img src={WorkLogo_18} alt="" />
          </div>
          <Text component="p" section="equipping">
            Ведущий российский разработчик и производитель
            контрольно-измерительных приборов и средств промышленной
            автоматизации. ОВЕН работает с 1991 года. За 25 лет тысячи
            предприятий автоматизировали свои технологические процессы,
            используя автоматику ОВЕН. С помощью оборудования ОВЕН можно
            создавать системы управления и диспетчеризации с применением
            проводных и беспроводных технологий связи.Официальный сайт
            <Link to="https://owen.ru/">
              <div> https://owen.ru/</div>
            </Link>
          </Text>
          <div className="page-kontrollery__content-img" id="kontrollery_GCAN">
            <img src={WorkLogo_19} alt="" />
          </div>
          <Text component="p" section="equipping">
            Контроллеры GCAN производит компания Shenyang Vhandy Technology Co.,
            Ltd. Компания находится в Шэньяне, промышленном центре на
            северо-востоке Китая. Это высокотехнологичное предприятие на базе
            Шэньянского технологического университета.Компания предоставляет
            клиентам такие продукты, как модули полевых шин и промышленные
            контроллеры и уже давно занимается разработкой и обслуживанием
            продуктов в области промышленной связи и промышленного управления.
            Компания имеет многолетний опыт работы в отрасли.Официальный сайт
            <Link to="https://www.plcsystems.ru/vendors/gcan/">
              <div> https://www.plcsystems.ru/vendors/gcan/</div>
            </Link>
          </Text>
          <div
            className="page-kontrollery__content-img"
            id="kontrollery_SEGNETICS"
          >
            <img src={WorkLogo_20} alt="" />
          </div>
          <Text component="p" section="equipping">
            Это российская компания, основанная в 2003 году. Основная
            деятельность компании – это разработка и производство
            программируемых логических контроллеров, но кроме этого
            разрабатываются и программное обеспечение, и инновационные
            технологии передачи данных. Рассмотрим каждый из аспектов
            подробнее.Руководствуясь принципами обеспечения наивысшего качества,
            Segnetics стремится полностью контролировать процесс производства
            своих устройств. При высоком уровне качества в изделия постоянно
            добавляются новые технологии, а линейка оборудования
            расширяется.Переход компании на новый уровень производства
            высокотехнологичных изделий произошел в 2014 году, когда была
            запущена в эксплуатацию полностью автоматизированная линия
            поверхностного монтажа SMD.Полная автоматизация линии позволяет
            исключить человеческий фактор при сборке приборов, а также
            значительно увеличить скорость производства.Официальный сайт
            <Link to="https://segnetics.com/">
              <div> https://segnetics.com/</div>
            </Link>
          </Text>
        </div>
      </div>
    </section>
  );
};
export default PageKontrollery;
